// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2i7el","nameBox":"nameBox___1ax7y","name":"name___34clA","dot":"dot___3-AqW","content":"content___3ltwZ"};